import { r as registerInstance, c as getContext, h, g as getElement } from './core-dafe424f.js';
var Content = /** @class */ (function () {
    function Content(hostRef) {
        registerInstance(this, hostRef);
        this.currentTheme = { components: [] };
        this.ContextStore = getContext(this, "store");
    }
    Content.prototype.setTheme = function (name) {
        if (name === void 0) { name = undefined; }
        this.theme = name || this.store.getState().theme.current;
        this.currentTheme = this.store.getState().theme.items[this.theme];
    };
    Content.prototype.componentWillLoad = function () {
        var _this = this;
        this.store = this.ContextStore || window.CorporateUi.store;
        this.setTheme(this.theme);
        this.store.subscribe(function () { return _this.setTheme(); });
        if (!(this.el && this.el.nodeName))
            return;
        this.tagName = this.el.nodeName.toLowerCase();
    };
    Content.prototype.render = function () {
        return [
            this.currentTheme ? h("style", null, this.currentTheme.components[this.tagName]) : '',
            // Move the router related things a router component
            // if (this.router) {
            //   return (
            //     <stencil-router>
            //       <stencil-route-switch scrollTopOffset={0}>
            //         <stencil-route url='/' component='app-home' exact={true} />
            //         <stencil-route url='/profile/:name' component='app-profile' />
            //       </stencil-route-switch>
            //     </stencil-router>
            //   );
            // } else {
            h("slot", null),
        ];
    };
    Object.defineProperty(Content.prototype, "el", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Content, "watchers", {
        get: function () {
            return {
                "theme": ["setTheme"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Content, "style", {
        get: function () { return ":host,:host *,:host :after,:host :before{-webkit-box-sizing:border-box;box-sizing:border-box}:host{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:0;flex-shrink:0;padding-left:20px;padding-right:20px}"; },
        enumerable: true,
        configurable: true
    });
    return Content;
}());
export { Content as c_content };
